<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Dashboard-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="addWidget" @rightTextClick="editWidgets" v-if="$store.getters.language.texts.isRTL" :rightText="editMode?$store.getters.language.texts.Dashboard_doneEditing:$store.getters.language.texts.Dashboard_editWidgets" :rightIcon="editMode?'save':'edit'" :leftText="$store.getters.language.texts.DashBoard_addWidget" leftIcon="plus" centerText=""></TopNav>
        <TopNav @leftTextClick="editWidgets" @rightTextClick="addWidget" v-else :rightText="$store.getters.language.texts.DashBoard_addWidget" rightIcon="plus" :leftText="editMode?$store.getters.language.texts.Dashboard_doneEditing:$store.getters.language.texts.Dashboard_editWidgets" :leftIcon="editMode?'save':'edit'" centerText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Dashboard-main-wrapper lxn-pos-rel">
      <div class="Dashboard-wrapper-widgets lxn-margin-auto lxn-border-round lxn-pos-rel lxn-overflow-hidden">
        <div v-if="folderId == 0" class="Dashboard-wrapper-schedule">
          <div @click="goToSchedules();" class="lxn-cursor-pointer">
            <ScheduleWidget></ScheduleWidget>
          </div>
        </div>
        <div v-if="folderId != 0" class="Dashboard-wrapper-folderName lxn-w100 lxn-pos-rel lxn-title lxn-text-center" :class="[$store.getters.language.font]">
          {{folderName}}
          <div class="Dashboard-wrapper-folderBack lxn-pos-abs">
            <ButtonIcon @click="folderBack()" :size="40" bgColor="#ffffff" icon="return" iconColor="#51616e" :padding="4" :isRound="false" :borderWidth="0" :onclickEffect="true" />
          </div>
        </div>
        <div v-if="widgetsCount == 0" class="Dashboard-wrapper-noWidget lxn-text-center" :class="[$store.getters.language.directionClass, $store.getters.language.font]">
          {{$store.getters.language.texts.DashBoard_noWidgets}}
        </div>
        <draggable v-model="widgets" :disabled="!editMode" handle=".widgetMoveHandle">
          <LuxinWidget v-show="showWidget(index)" v-for="(widget, index) in widgets" :key="index" :index="index" :editing="editMode">
            <component v-bind:is="$store.state.widgets[index].type" :index="index"></component>
          </LuxinWidget>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import AcRemoteWidget from '@/components/widgets/AcRemoteWidget.vue'
import DoubleSwitchWidget from '@/components/widgets/DoubleSwitchWidget.vue'
import FolderWidget from '@/components/widgets/FolderWidget.vue'
import HumidityWidget from '@/components/widgets/HumidityWidget.vue'
import LuxinWidget from '@/components/widgets/LuxinWidget.vue'
import rgbwWidget from '@/components/widgets/RGBWWidget.vue'
import S1TouchWidget from '@/components/widgets/S1TouchWidget.vue'
import SceneButtonWidget from '@/components/widgets/SceneButtonWidget.vue'
import ScheduleWidget from '@/components/widgets/ScheduleWidget.vue'
import SingleSwitchWidget from '@/components/widgets/SingleSwitchWidget.vue'
import SingleThreewaySwitchWidget from '@/components/widgets/SingleThreewaySwitchWidget.vue'
import SmartCurtainWidget from '@/components/widgets/SmartCurtainWidget.vue'
import TemperatureAutomationWidget from '@/components/widgets/TemperatureAutomationWidget.vue'
import TemperatureWidget from '@/components/widgets/TemperatureWidget.vue'
import TvRemoteWidget from '@/components/widgets/TvRemoteWidget.vue'
import draggable from 'vuedraggable'

export default {
  name: 'dashboard',
  components: {
    CustomCurve,
    TopNav,
    LuxinWidget,
    SingleSwitchWidget,
    SceneButtonWidget,
    draggable,
    ScheduleWidget,
    TemperatureAutomationWidget,
    rgbwWidget,
    SmartCurtainWidget,
    DoubleSwitchWidget,
    AcRemoteWidget,
    TemperatureWidget,
    HumidityWidget,
    TvRemoteWidget,
    FolderWidget,
    ButtonIcon,
    SingleThreewaySwitchWidget,
    S1TouchWidget
  },
  mounted: function () {
    this.$store.commit('editActiveDashboardFolderId', this.$route.params.folderId);
    for(var i = 0; i < this.$store.state.hubs.length; i++){
      this.$store.commit('setHubStatus', {
        hubIndex: i,
        stateUpdateEnabled: true,
      });
    }
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
  },
  data: function () {
    return {
      editMode: false,
    }
  },
  watch: {
    folderId: function (newVal) {
      this.$store.commit('editActiveDashboardFolderId', this.$route.params.folderId);
    }
  },
  computed: {
    folderId: function () {
      return this.$route.params.folderId;
    },
    folderWidget: function () {
      var folderWidget = this.$store.state.widgets.filter( widget => widget.settings.path == this.folderId);
      if(folderWidget.length){
        return folderWidget[0];
      }else{
        return {
          name: "undefined",
        }
      }
    },
    folderName: function () {
      var parentPath = this.folderWidget.settings.parent;
      var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
      var folderName = this.folderWidget.name;
      while(parentFolder.length){
        folderName = parentFolder[0].name + " > " + folderName;
        parentPath = parentFolder[0].settings.parent;
        parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
      }
      return folderName;
    },
    widgetsCount: function () {
      var widgets = this.$store.state.widgets.filter( widget => widget.path == this.folderId || (widget.path == undefined && this.folderId == 0));
      return widgets.length;
    },
    widgets: {
        get() {
          return this.$store.state.widgets;
        },
        set(value) {
            this.$store.commit('updateWidgets', value)
        }
    },
  },
  methods: {
    openMenu: function () {
      this.$root.openMenu();
    },
    showWidget: function (index) {
      var widget = this.$store.state.widgets[index];
      return widget.path == this.folderId || (widget.path == undefined && this.folderId == 0);
    },
    editWidgets: function () {
      if(!this.editMode){
        this.editMode = true;
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('saveState');
        this.editMode = false;
        this.$store.commit('setAppBusy', false);
      }
    },
    addWidget: function () {
      this.$router.push("/addNewWidget/");
    },
    goToSchedules: function () {
      this.$router.push("/schedules/");
    },
    folderBack: function () {
      this.$router.push("/home/dashboard/" + this.folderWidget.settings.parent);
    },
  }
}
</script>

<style>
  .Dashboard-topCurve-wrapper {
    height: 150px;
  }
  .Dashboard-main-wrapper {
    margin-top: -100px;
    margin-bottom: 14px;
    z-index: 2;
  }
  .Dashboard-wrapper-luxi {
    width: calc(100% - 36px);
    height: 100px;
    background-color: #ffffff;
    padding: 10px;
    z-index: 1;
    margin-bottom: 10px;
  }
  .Dashboard-wrapper-noWidget {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .Dashboard-wrapper-schedule {
    padding-left: 5px;
    padding-right: 5px;
  }
  .Dashboard-wrapper-widgets {
    width: calc(100% - 36px);
    background-color: #ffffff;
    padding-top: 10px;
    padding-bottom: 0;
    padding-left: 5px;
    padding-right: 5px;
    z-index: 1;
    margin-bottom: 14px;
  }
  .Dashboard-wrapper-addWidgetButton {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .Dashboard-wrapper-folderName {
    height: 50px;
    line-height: 50px;
    color: #51616e;
  }
  .Dashboard-wrapper-folderBack {
    left: 0;
    top: 0;
  }
</style>